import flagKeys from '@/constants/flagKeys';
import CustomersList from '@/views/CustomersList/CustomersList.vue';
import { Route } from '../route.model';

const customersList = new Route('/customers', 'customer', CustomersList, {
  requiresAuth: true,
  isResponsive: flagKeys.responsiveDashboard,
  flag: flagKeys.legacyReports,
  zendesk: {
    mobile: {
      offsetHorizontal: '4px',
      offsetVertical: '4px'
    }
  },
  navbar: {
    name: 'Customers List', // TODO apply i18n
    icon: 'customer-center'
  }
});

export { customersList };
export default customersList;
